<template>
  <base-card>
    <div class="domains left">
      <div class="border-bottom padding-bottom">
        <h4>Die vier Ebenen der Matrix of Domination</h4>
      </div>
      <div class="domain">
        <h4>Strukturelle Ebene</h4>
        <p>Organisiert Unterdrückung: Gesetzte und Richtlinien</p>
      </div>
      <div class="domain">
        <h4>Disziplinäre Ebene</h4>
        <p>
          Verwaltet Unterdrückung: Umsetzung und Auführung von Gesetzten und
          Richtlinien
        </p>
      </div>
      <div class="domain">
        <h4>Hegemoniale Ebene</h4>
        <p>Verbreitet unterdrückende Ideen: Kultur und Medien</p>
      </div>
      <div class="domain">
        <h4>Zwischenmenschliche Ebene</h4>
        <p>Individuelle Erfahrungen mit Unterdrückung</p>
      </div>
      <div class="footnote">
        <p> Basierend auf dem Konzept von Patricia Hill Collins in Black Feminist
        Thought: Knowledge, Consciousness and the Politics of Empowerment.</p>
        <p>Quelle: D'Ignazio, Catherine und Klein, Lauren F. (2020): Data Feminism,
        Massachusetts Institute of Technology</p>
      </div>
    </div>
  </base-card>
</template>

<style scoped>
.domains {
  width: 100%;
}
.domain {
  margin-top: 20px;
}
h4,
p {
  margin: 0;
}
.footnote {
    margin-top: 10px;
}
</style>